import { color, Root } from '@amcharts/amcharts5';

import { toolTip } from 'utils/charts/charts';
import { SHADOW, TRANSPARENT } from 'utils/colours';

export const setTooltip = (root: Root) => {
  const tooltip = toolTip(root, {
    getFillFromSprite: false,
    getStrokeFromSprite: false,
    pointerOrientation: 'horizontal',
  });

  tooltip.get('background')?.setAll({
    fill: color(TRANSPARENT),
    fillOpacity: 1,
    stroke: color(TRANSPARENT),
    shadowColor: color(SHADOW),
    shadowBlur: 16,
    shadowOffsetX: 0,
    shadowOffsetY: 4,
    shadowOpacity: 0.15,
  });
  return tooltip;
};
